export default __webpack_public_path__ + "static/media/text_event.b4f9e1de.webp";